import React from 'react';
import { Thumbnail, token } from '@bynder/design-system';
import { IconReplay } from '@bynder/icons';
import { ApplyFont, LettersThumbnail, OverrideIcon } from '../Component.styled';

const FontThumbnail = ({
    id,
    url,
    overrides = 0,
    isActive,
}: {
    id: string;
    url: string;
    overrides?: number;
    isActive: boolean;
}) => (
    <LettersThumbnail
        variant="clean"
        backgroundColor="white"
        icon={
            <ApplyFont name={id} fontUrl={url}>
                Aa
            </ApplyFont>
        }
    >
        {overrides > 0 && (
            <OverrideIcon>
                <IconReplay style={{ color: token.gray10 }} size="12" />
            </OverrideIcon>
        )}
        {!isActive && <Thumbnail.Indicator backgroundColor="orange500" icon={undefined} />}
    </LettersThumbnail>
);

export default FontThumbnail;
